// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__2BuIz","wrapper":"Table_wrapper__3o3AJ","table":"Table_table__1EkTQ","addButton":"Table_addButton__1cgZk","addRowButton":"Table_addRowButton__VRnKw"};